export const getInitialProps = async ({context, routeInfo}) => {
  const {
    domain,
    i18n: {culture}
  } = context
  const {location} = routeInfo

  const {pathname} = location

  const _getPageName = () => domain.get('get_page_name_page_use_case').execute({path: pathname})

  const _getSeoData = pageName => domain.get('get_seo_data_use_case').execute({culture, pageName})

  const _getPageTrackingData = pageName => domain.get('get_page_tracking_data_use_case').execute({page: pageName})

  const [
    {
      value: {pageName}
    }
  ] = await Promise.allSettled([_getPageName()])

  const [
    {
      value: [seoDataError, seoDataResponse]
    },
    {value: trackingDataResponse}
  ] = await Promise.allSettled([_getSeoData(pageName), _getPageTrackingData(pageName)])

  return {
    helmet: seoDataError ? {} : seoDataResponse?.head || {},
    pageTrackingData: trackingDataResponse || {}
  }
}
